import { actions, withAuth } from 'store';
import { Register } from 'components/register';

const RegisterPage = ({ messages }) => <Register />;

RegisterPage.getInitialProps = async ({ reduxStore }) => {
  const state = reduxStore.getState();
  if (!state.serverConfig || !state.serverConfig.enableRegistration) {
    const error = new Error();
    // @ts-ignore
    error.response = { status: 404 };
    throw error;
  }

  reduxStore.dispatch(actions.setInitialPageState({ error: false }));
  return {};
};

export default withAuth(['PUBLIC'])(RegisterPage);
